import { useEffect, useState } from 'react';
import { removeSessionCookies } from 'components/sessionTimeOut/utils/removeSessionCookies';
import { SESSION_STATUS } from 'components/sessionTimeOut/constants';

export const useExpirationModalCheck = ({ session, onExpirationModalOpen, modalCancelActions }) => {
    const [{ showExpiredModal, expiredBlowupClass, isExitClicked }, setExpirationModalConfig] = useState(false);

    const openExpirationModal = () => {
        modalCancelActions.hideModalCancel();
        onExpirationModalOpen();
        setExpirationModalConfig(prevState => ({
            ...prevState,
            showExpiredModal: true,
            expiredBlowupClass: 'blowup-modal blowup-in',
        }));

        removeSessionCookies();
    };

    const closeExpirationModal = () => {
        setExpirationModalConfig(prevState => ({
            ...prevState,
            isExitClicked: true,
            expiredBlowupClass: 'blowup-modal blowup-out',
        }));

        setTimeout(() => {
            setExpirationModalConfig(prevState => ({ ...prevState, showExpiredModal: false }));
        }, 200);
    };

    const checkExpirationModalCondition = () => {
        const sessionStatus = session.get('sessionStatus');
        const minLeft = sessionStatus.get('minLeft');
        const secLeft = sessionStatus.get('secLeft');
        const status = sessionStatus.get('status');
        const closed = sessionStatus.get('closed');
        const expired = sessionStatus.get('expired');
        const isTimeOut = minLeft <= 0 && secLeft < 0;
        const expiredCondition = (status === SESSION_STATUS.EXPIRED || expired || isTimeOut) && !closed;

        expiredCondition && !showExpiredModal && !isExitClicked && openExpirationModal();
    };

    useEffect(() => {
        checkExpirationModalCondition();
    }, [session]);

    return { showExpiredModal, expiredBlowupClass, openExpirationModal, closeExpirationModal };
};
